import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { Alert } from "../../common/Alert";
import { AUTOCOMPLETE_TYPE, NOTIFICATION_MESSAGE_TYPE } from "../../constants";
import { PRODUCT_PLACEHOLDER } from "../../constants/Placeholders";
import upIcon from "../../assets/images/chevronUp.svg";
import downIcon from "../../assets/images/chevronDown.svg";
import liveTrack from "../../assets/images/liveTrackGold.gif";
import sortIcon from "../../assets/images/sortIcon.svg";
import sortDownIcon from "../../assets/images/sortIconDown.svg";
import sortUpIcon from "../../assets/images/sortIconUp.svg";
import AirportAutocomplete from "../AirportAutocomplete";
import ProductAutocomplete from "../ShippingItemAutocomplete/ProductAutoComplete";
import "./TrackShipmentListView.scss";
import { useTranslation } from "react-i18next";
import LoadingIndicator from "../LoadingIndicator";
import { getProducts } from "../../services/manageBookingService";
import { getAirportsByCode } from "../../services/searchPanelServices";
import getCurrentUser from "../../utils/getCurrentUser";
import { addError } from "../../utils/analytics";
import {
  allowNumricOnly,
  formatInputTypeNumber,
  formatShippingDescription,
  getFormattedDataForTable,
  getShipmentsListRequest,
  isMoreThan30Days,
  removeError,
  validateAWB,
  validateAwbPrefixRequired,
} from "./ShipmentTrackingUtils";
import {
  getAwbLiveTrackingUrl,
  getAwbsLiveTrackingUrl,
  getLiveTrackList,
  getShipmentDetailsByCode,
  getShipmentsList,
} from "../../services/transportationPlanServices";
import PaginatorComponent from "../Pagination/PaginatorComponent";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import {
  getFromLocalStorage,
  setToLocalStorage,
} from "../../utils/StorageUtils";
import sessionKeys from "../../constants/sessionKeys";
import Messages from "../../constants/Messages";
import CommonInput from "../../common/Resusable/CommonInput";
import { CommonDropDown } from "../../common/Resusable/CommonDropDown";
import { CommonFilter } from "../../common/CommonFilter/CommonFilter";
import { Divider } from "../../common/Divider";
import { SelectButton } from "primereact/selectbutton";
import getPrincipal from "../../utils/getPrincipal";
import { useDispatch, useSelector } from "react-redux";
import { setMasterDataDetails } from "../../redux/actions/masterDataActions";

const TrackShipmentListView = () => {
  const { t } = useTranslation(["labels", "errors"]);
  const masterData = useSelector(state => state?.masterData);
    const dispatch = useDispatch();
  const searchPanelInitialData = {
    origin: null,
    destination: null,
    fromBookingDate: moment(
      new Date().setDate(new Date().getDate() - 14)
    ).toDate(),
    toBookingDate: new Date(),
    shipmentIdentifierDetails: {
      shipmentPrefix: "607",
      masterDocumentNumber: "",
    },
    advancedSearch: {
      product: null,
      bookingStatus: null,
    },
    agentCode: null,
  };

  const filterOptionsValues = [
    { label: t("COMMON.ALL"), value: "All" },
    {
      label: (
        <div className="icon-with-label">
          <img src={require("../../assets/images/tick-blue.svg").default} />
          {t("COMMON.BOOKED")}
        </div>
      ),
      value: "Booked",
    },
    {
      label: (
        <div className="icon-with-label">
          <img
            src={require("../../assets/images/airplane-green.svg").default}
          />
          {t("COMMON.LIVE")}
        </div>
      ),
      value: "Live",
    },
    {
      label: (
        <div className="icon-with-label">
          <img
            src={require("../../assets/images/thumbs-up-grey.svg").default}
          />
          {t("COMMON.COMPLETED")}
        </div>
      ),
      value: "Completed",
    },
  ];

  const history = useHistory();
  const location = useLocation();
  const isError = location.state?.isError;
  const principalData = getPrincipal()

  const SHIPMENT_STATUS = [
    { label: t("COMMON.ALL"), value: "All" },
    { label: t("COMMON.CONFIRMED"), value: "Confirmed" },
    { label: t("COMMON.QUEUED"), value: "Queued" },
    { label: t("COMMON.ACCEPTED"), value: "Accepted" },
    { label: t("COMMON.INTRANSIT"), value: "In-Transit" },
    { label: t("COMMON.INTRANSITSPLIT"), value: "In-Transit (Split)" },
    { label: t("COMMON.ARRIVED"), value: "Arrived" },
    {
      label: t("COMMON.NOTIFIED_FOR_DELIVERY"),
      value: "Notified for Delivery",
    },
    { label: t("COMMON.DELIVERED"), value: "Delivered" },
  ];

  const [bookingSearchFormData, setBookingSearchFormData] = useState(
    searchPanelInitialData
  );
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [awbList, setAwbList] = useState([]);
  const [advancedSearch, setAdvancedSearch] = useState(false);
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const [paginationData, setPaginationData] = useState({
    currentPageNumber: 0,
    recordsPerPage: 0,
    totalPages: 0,
    combinedPages: 0,
  });

  const [notificationType, setNotificationType] = useState(null);
  const [notificationMessage, setNotificationMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [sortField, setSortField] = useState({ sortBy: "", sortOrder: "" });

  const shipmentInfoCache = useRef(new Map());

  const [statusFilters, setStatusFilters] = useState(["All"]);

  const [trackAwbs, setTrackAwbs] = useState(null);

  const [isEnterpriseUser, setIsEnterpriseUser] = useState(false);

  const [isShowSmartTrack, setIsShowSmartTrack] = useState(false);

  const DATE_LIMIT_ERROR = "Date range can’t exceed 30 days";

  const clearError = () => { };

  const showErrorAlert = () => {
    setNotificationMessage(
      t(Messages.PROCESS_REQUEST_FAILED, { ns: "errors" })
    );
    setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
  };

  const isEmpty = (value) => (value ? value?.trim()?.length === 0 : true);

  const setShipmentListAndPaginationData = async (
    response,
    smartTrackResponse
  ) => {
    const {
      transportationPlans,
      totalPages,
      pageNumber,
      pageSize,
      toaStatusFilters,
    } = response.data;

    const smartTrackList = smartTrackResponse?.data?.liveTrackDetails || [];

    if (smartTrackList) {
      setTrackAwbs(smartTrackList);
    }
    setIsShowSmartTrack(smartTrackResponse?.data?.showSmarttrack || false);

    if (transportationPlans) {
      const fetchPromises = {};
      let modifiedTransportationPlan = await Promise.all(
        transportationPlans.map(async (eachPlan) => {
          const { commodity, product, sccCode, awbNumber } = eachPlan || {};
          const awbShipmentID = smartTrackList?.find(
            (item) => item?.liveTrackedAwb?.trim() === awbNumber?.trim()
          )?.shipmentId;
          const modifiedPlan = {
            ...eachPlan,
            trackedShipmentID: awbShipmentID || null,
          };
          if (commodity) {
            let shipmentInfoObj = shipmentInfoCache.current.get(commodity);
            if (shipmentInfoObj) {
              return {
                ...modifiedPlan,
                shipmentInfo: formatShippingDescription(shipmentInfoObj),
              };
            } else {
              if (!fetchPromises[commodity]) {
                fetchPromises[commodity] = getShipmentDetailsByCode(commodity)
                  .then((res) => {
                    const shipmentDetails = res?.data;
                    if (shipmentDetails) {
                      shipmentInfoCache.current.set(commodity, shipmentDetails);
                    }
                    return shipmentDetails;
                  })
                  .catch(() => null);
              }
              const shipmentDetails = await fetchPromises[commodity];
              return {
                ...modifiedPlan,
                shipmentInfo: shipmentDetails
                  ? formatShippingDescription(shipmentDetails)
                  : formatShippingDescription({
                    description: product,
                    product: commodity,
                    scc: sccCode,
                  }),
              };
            }
          }
          return {
            ...modifiedPlan,
            shipmentInfo: "",
          };
        })
      );
      setAwbList(modifiedTransportationPlan);
      setPaginationData({
        currentPageNumber: pageNumber ? pageNumber + 1 : 0,
        combinedPages: totalPages * pageSize,
        recordsPerPage: pageSize,
        totalPages,
      });
      if (toaStatusFilters) {
        setStatusFilters(toaStatusFilters);
      }
    }
  };

  const fetchShipmentsAndSmartTrack = async (requestBody) => {
    const [shipmentsResult, smartTrackResult] = await Promise.allSettled([
      getShipmentsList(requestBody),
      getLiveTrackList(requestBody),
    ]);
    return {
      response: shipmentsResult.status === "fulfilled" ? shipmentsResult.value : null,
      smartTrackResponse: smartTrackResult.status === "fulfilled" ? smartTrackResult.value : null,
    };
  };



  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);

    const isAwbValid = validateAWB(
      bookingSearchFormData?.shipmentIdentifierDetails?.masterDocumentNumber?.trim(),
      setError,
      "awbNumber"
    );
    const isAwbPrefixValid = validateAwbPrefixRequired(
      bookingSearchFormData?.shipmentIdentifierDetails?.masterDocumentNumber?.trim(),
      bookingSearchFormData?.shipmentIdentifierDetails?.shipmentPrefix,
      setError,
      "awbPrefix"
    );
    const isAwbFieldEmpty =
      bookingSearchFormData?.shipmentIdentifierDetails?.masterDocumentNumber?.trim()
        ?.length === 0;

    let isDateError = false;

    if (isAwbFieldEmpty) {
      const { fromBookingDate, toBookingDate } = bookingSearchFormData || {};
      if (!fromBookingDate) {
        setError((prevState) => ({
          ...prevState,
          fromBookingDate: Messages.FIELD_REQUIRED,
        }));
        isDateError = true;
      } else if (!toBookingDate) {
        setError((prevState) => ({
          ...prevState,
          toBookingDate: Messages.FIELD_REQUIRED,
        }));
        isDateError = true;
      } else if (fromBookingDate && toBookingDate) {
        if (isMoreThan30Days(fromBookingDate, toBookingDate)) {
          setError((prevState) => ({
            ...prevState,
            fromBookingDate: DATE_LIMIT_ERROR,
            toBookingDate: DATE_LIMIT_ERROR,
          }));
          isDateError = true;
        } else {
          setError((prevState) => ({
            ...prevState,
            fromBookingDate: "",
            toBookingDate: "",
          }));
        }
      }
    }

    if (isAwbValid && isAwbPrefixValid && !isDateError) {
      try {
        setIsLoading(true);
        const requestBody = getShipmentsListRequest(
          bookingSearchFormData,
          selectedFilter
        );
        const { response, smartTrackResponse } = await fetchShipmentsAndSmartTrack(requestBody);
        if (response?.data) {
          await setShipmentListAndPaginationData(response, smartTrackResponse);
          setStatusFilters(["All"]);
        }
      } catch (error) {
        console.log(error.message);
        addError("SHIPMENTS_LIST_ERROR", error);
        showErrorAlert();
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSetError = (key, text) => {
    error
      ? setError({
        ...error,
        [key]: text,
      })
      : setError({
        [key]: text,
      });
  };

  const handleAlertClose = () => {
    setNotificationMessage("");
    setNotificationType(null);
  };

  const draftCallback = () => { };

  // Handler to change filter
  const handleFilterChange = async (filter) => {
    try {
      setIsLoading(true);
      const requestBody = getShipmentsListRequest(bookingSearchFormData, filter)
      const { response, smartTrackResponse } = await fetchShipmentsAndSmartTrack(requestBody);
      if (response?.data) {
        await setShipmentListAndPaginationData(response, smartTrackResponse);
        setSelectedFilter(filter);
        setSortField({ sortBy: "", sortOrder: "" });
        setStatusFilters(["All"]);
      }
    } catch (error) {
      console.log(error.message);
      addError("SHIPMENTS_LIST_ERROR", error);
      showErrorAlert();
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeOfAWB = (value) => {
    if (value.length <= 12) {
      setBookingSearchFormData((prev) => ({
        ...prev,
        shipmentIdentifierDetails: {
          ...prev?.shipmentIdentifierDetails,
          masterDocumentNumber: value,
        },
      }));
    }
  };

  const advancedSearchAction = (isOpen) => {
    setBookingSearchFormData((prev) => ({
      ...prev,
      advancedSearch: {
        product: isOpen
          ? {
            name: "All",
          }
          : null,
        bookingStatus: isOpen ? "All" : null,
      },
    }));
    setAdvancedSearch(isOpen);
  };

  const onPageIndexChange = async (e) => {
    try {
      setIsLoading(true);
      const requestBody = getShipmentsListRequest(
        bookingSearchFormData,
        selectedFilter,
        e,
        sortField,
        statusFilters
      );
      const { response, smartTrackResponse } = await fetchShipmentsAndSmartTrack(requestBody);
      if (response?.data) {
        await setShipmentListAndPaginationData(response, smartTrackResponse);
      }
    } catch (error) {
      console.log(error.message);
      addError("SHIPMENTS_LIST_ERROR", error);
      showErrorAlert();
    } finally {
      setIsLoading(false);
    }
  };

  const viewClickHandler = (shipmentData) => {
    setToLocalStorage(
      sessionKeys.SHIPMENT_TRACKING_DETAILS,
      JSON.stringify({
        bookingSearchFormData,
        selectedFilter,
        paginationData,
        sortField,
        statusFilters,
      })
    );
    history.push("/shipment-tracking/view", {
      awbNumber: shipmentData?.awbNumber,
    });
  };


  const handleSort = async (field) => {
    const { sortOrder, sortBy } = sortField;
    const isSameFieldClicked = field === sortBy;
    let newSortOrder = isSameFieldClicked ? sortOrder : "";
    switch (newSortOrder) {
      case "asc":
        newSortOrder = "desc";
        break;
      case "desc":
        newSortOrder = "";
        break;
      case "":
        newSortOrder = "asc";
        break;
      default:
        newSortOrder = "";
    }
    const sortData = {
      sortBy: field,
      sortOrder: newSortOrder,
    };
    try {
      setIsLoading(true);
      const requestBody = getShipmentsListRequest(
        bookingSearchFormData,
        selectedFilter,
        paginationData.currentPageNumber,
        sortData,
        statusFilters
      )
      const { response, smartTrackResponse } = await fetchShipmentsAndSmartTrack(requestBody);
      if (response?.data) {
        setSortField(sortData);
        await setShipmentListAndPaginationData(response, smartTrackResponse);
      }
    } catch (error) {
      console.log(error.message);
      addError("SHIPMENTS_LIST_ERROR", error);
      showErrorAlert();
    } finally {
      setIsLoading(false);
    }
  };

  const getSortArrowByType = (sortDetails, type) => {
    const { sortBy, sortOrder } = sortDetails;
    if (sortBy && sortBy === type) {
      switch (sortOrder) {
        case "asc":
          return sortUpIcon;
        case "desc":
          return sortDownIcon;
        default:
          return sortIcon;
      }
    } else {
      return sortIcon;
    }
  };

  const onFilterOptionsChange = (value) => {
    setStatusFilters((prev) => {
      const updated = prev.filter((f) => f !== "All");
      if (updated.includes(value)) {
        return updated.filter((f) => f !== value);
      }
      return [...updated, value];
    });
  };

  const filterOnClickHandler = async () => {
    try {
      setIsLoading(true);
      const requestBody = getShipmentsListRequest(
        bookingSearchFormData,
        selectedFilter,
        paginationData.currentPageNumber,
        sortField,
        statusFilters
      )
      const { response, smartTrackResponse } = await fetchShipmentsAndSmartTrack(requestBody);
      if (response?.data) {
        await setShipmentListAndPaginationData(response, smartTrackResponse);
      }
    } catch (error) {
      console.log(error.message);
      addError("SHIPMENTS_LIST_ERROR", error);
      showErrorAlert();
    } finally {
      setIsLoading(false);
    }
  };

  const handleSmartTrackClick = (trackedShipmentID) => {
    const url = getAwbLiveTrackingUrl(trackedShipmentID, isEnterpriseUser);
    console.log("AWB URL", url);
    window.open(url, "_blank");
  };

  const allSmartTrackLinkClick = () => {
    const awbList = trackAwbs?.map((item) => item?.liveTrackedAwb?.replace("-", ""));
    const url = getAwbsLiveTrackingUrl(awbList, isEnterpriseUser);
    console.log("AWBs URL", url);
    window.open(url, "_blank");
  };

  const resetFilterClickHandler = () => {
    setStatusFilters(["All"]);
  }

  const awbRowClickHandler = (shipment) => {
    setToLocalStorage(
      sessionKeys.SHIPMENT_TRACKING_DETAILS,
      JSON.stringify({
        bookingSearchFormData,
        selectedFilter,
        paginationData,
        sortField,
        statusFilters
      })
    );
    const { awbNumber, ubrNumber } = shipment;
    const urlString = `/manage-booking/${awbNumber?.replaceAll("-", "")}${ubrNumber ? `/${ubrNumber}` : ""
      }`;
    history.push(urlString.trim(), { callerScreen: "ShipmentTracking" });
  };

  useEffect(() => {
    (async () => {
      const bookingData = getFromLocalStorage(
        sessionKeys.SHIPMENT_TRACKING_DETAILS
      );
      let selectedFilter = "All";
      let initialBookingData = searchPanelInitialData;
      let defaultOriginCode = null;
      let paginationDataInitial = {
        currentPageNumber: 0,
        recordsPerPage: 0,
        totalPages: 0,
        combinedPages: 0,
      };
      let sortFieldInitalData = { sortBy: "", sortOrder: "" };
      let initialStatusFilters = ["All"];
      if (bookingData) {
        const storedData = JSON.parse(bookingData);
        const parsedData = storedData?.bookingSearchFormData;
        selectedFilter = storedData?.selectedFilter;
        paginationDataInitial = storedData?.paginationData;
        sortFieldInitalData = storedData?.sortField;
        initialStatusFilters = storedData?.statusFilters;
        if (
          parsedData?.advancedSearch?.product ||
          parsedData?.advancedSearch?.bookingStatus
        ) {
          setAdvancedSearch(true);
        }
        initialBookingData = parsedData;
        setBookingSearchFormData(parsedData);
      } else if (!bookingSearchFormData.origin) {
        const gsaAgentDetails = JSON.parse(
          getFromLocalStorage(sessionKeys.GSA_AGENT_DETAILS)
        );
        const userDetails = getCurrentUser();
        let defaultAirport =
          userDetails && userDetails.defaultAirportCode
            ? userDetails.defaultAirportCode
            : userDetails?.stationCode;
        if (gsaAgentDetails && gsaAgentDetails?.agentDefaultAirportCode) {
          // defaultAirport = gsaAgentDetails.agentStationCode;
          defaultAirport = gsaAgentDetails && gsaAgentDetails.agentDefaultAirportCode ? gsaAgentDetails.agentDefaultAirportCode : gsaAgentDetails.agentStationCode;
        }
        if (userDetails && defaultAirport) {
          await getAirportsByCode(defaultAirport)
            .then((defaultOrigin) => {
              if (defaultOrigin) {
                defaultOriginCode = defaultOrigin;
                setBookingSearchFormData((prev) => ({
                  ...prev,
                  origin: defaultOrigin,
                }));
              }
            })
            .catch((error) => {
              console.log(error);
              addError("LOADING_ERROR", error);
            });
        }
      }
      try {
        setIsLoading(true);
        const requestBody = getShipmentsListRequest(
          bookingData
            ? initialBookingData
            : { ...initialBookingData, origin: defaultOriginCode },
          selectedFilter,
          paginationDataInitial.currentPageNumber,
          sortFieldInitalData,
          initialStatusFilters
        )
        const { response, smartTrackResponse } = await fetchShipmentsAndSmartTrack(requestBody);
        if (response?.data) {
          await setShipmentListAndPaginationData(response, smartTrackResponse);
          setSelectedFilter(selectedFilter);
          setSortField(sortFieldInitalData);
        }
      } catch (error) {
        console.log(error.message);
        addError("SHIPMENTS_LIST_ERROR", error);
        showErrorAlert();
      } finally {
        setIsLoading(false);
      }
    })();

    (async () => {
      try {
        // const productList = await getProducts();
        let productList = [];
        if (masterData?.productsMaster && masterData.productsMaster.length > 0) {
          // productList = masterData.productsMaster;
          productList = [...masterData.productsMaster];
        } else {
          productList = await getProducts();
          if (productList && productList.length > 0) {
            const masterDataPayload = {
              ...masterData,
              productsMaster: productList
            };
            dispatch(setMasterDataDetails(masterDataPayload));
            productList = [...productList];
          }
        }
        const allOption = {
          name: "All",
        };
        productList.unshift(allOption);
        if (productList) {
          setProducts(productList);
        }
      } catch (error) {
        console.log(error.message);
        addError("LOADING_PRODUCT_ERROR", error);
      }
    })();

    if (isError) {
      showErrorAlert();
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (principalData?.type === "enterprise") {
      setIsEnterpriseUser(true)
    }
    else {
      setIsEnterpriseUser(false)
    }
  }, [principalData])

  return (
    <div className="shipment-track-container">
      {notificationMessage && notificationMessage !== "" && (
        <Alert
          showAlert={true}
          message={t(notificationMessage, { ns: "errors" })}
          setTimeout={true}
          onAlertClose={handleAlertClose}
          type={notificationType}
        />
      )}
      {isLoading ? <LoadingIndicator /> : <></>}
      <div className="shipment-track-search">
        <h3>{t("MY_SHIPMENTS.TRACK_SHPMNT")}</h3>
        <div className="shipment-input-section">
          <div className="input-row">
            <div className="form-group common-autocomplete">
              <div className="p-float-label input-wrapper">
                <AirportAutocomplete
                  autoCompleteType={AUTOCOMPLETE_TYPE.ORIGIN}
                  selectedOrigin={bookingSearchFormData?.origin}
                  selectedDestination={bookingSearchFormData?.destination}
                  setSelectedOrigin={(e) =>
                    setBookingSearchFormData((prev) => ({ ...prev, origin: e }))
                  }
                  handleSetError={handleSetError}
                  clearError={clearError}
                  draftCallback={draftCallback}
                  setNotificationMessage={setNotificationMessage}
                  setNotificationType={setNotificationType}
                />
                <label>{t("COMMON.SHP_FROM")}</label>
              </div>
            </div>
            <div className="form-group common-autocomplete">
              <div className="p-float-label input-wrapper">
                <AirportAutocomplete
                  autoCompleteType={AUTOCOMPLETE_TYPE.DESTINATION}
                  selectedOrigin={bookingSearchFormData?.origin}
                  selectedDestination={bookingSearchFormData?.destination}
                  setSelectedDestination={(e) =>
                    setBookingSearchFormData((prev) => ({
                      ...prev,
                      destination: e,
                    }))
                  }
                  handleSetError={handleSetError}
                  clearError={clearError}
                  draftCallback={draftCallback}
                  setNotificationMessage={setNotificationMessage}
                  setNotificationType={setNotificationType}
                />
                <label>{t("COMMON.SHP_TO")}</label>
              </div>
            </div>
          </div>

          <div className="input-row">
            <div className="form-group">
              <CommonInput
                type="calendar"
                value={
                  moment(bookingSearchFormData.fromBookingDate).isValid()
                    ? moment(bookingSearchFormData.fromBookingDate).toDate()
                    : null
                }
                minDate={moment(new Date(2025, 4, 15)).toDate()}
                onChange={(e) => {
                  setBookingSearchFormData({
                    ...bookingSearchFormData,
                    fromBookingDate: e.target?.value,
                  });
                }}
                onFocus={(e) => {
                  setError((prevState) => ({
                    ...prevState,
                    ["fromBookingDate"]: "",
                    ["toBookingDate"]:
                      error?.["toBookingDate"] === DATE_LIMIT_ERROR
                        ? ""
                        : prevState?.toBookingDate,
                  }));
                }}
                label={t("SHIPMENT_LIST.SHP_CREATION_FRM")}
                error={
                  error && error["fromBookingDate"]
                    ? t(error["fromBookingDate"], { ns: "errors" })
                    : ""
                }
              />
            </div>

            <div className="form-group">
              <CommonInput
                type="calendar"
                label={t("SHIPMENT_LIST.SHP_CREATION_TO")}
                value={
                  moment(bookingSearchFormData.toBookingDate).isValid()
                    ? moment(bookingSearchFormData.toBookingDate).toDate()
                    : null
                }
                minDate={moment(new Date(2025, 4, 15)).toDate()}
                onChange={(e) => {
                  setBookingSearchFormData({
                    ...bookingSearchFormData,
                    toBookingDate: e.target?.value,
                  });
                }}
                onFocus={(e) => {
                  setError((prevState) => ({
                    ...prevState,
                    ["toBookingDate"]: "",
                    ["fromBookingDate"]:
                      error?.["fromBookingDate"] === DATE_LIMIT_ERROR
                        ? ""
                        : prevState?.fromBookingDate,
                  }));
                }}
                error={
                  error && error["toBookingDate"]
                    ? t(error["toBookingDate"], { ns: "errors" })
                    : ""
                }
              />
            </div>
          </div>
          <div className="input-row">
            <div className={`form-group awb-input-section`}>
              <CommonInput
                type="text"
                inputType="number"
                label={t("COMMON.PREFIX")}
                value={
                  bookingSearchFormData?.shipmentIdentifierDetails
                    ?.shipmentPrefix
                }
                maxLength="3"
                onKeyPress={(evt) => {
                  return allowNumricOnly(evt);
                }}
                onChange={(e) => {
                  const { value } = e?.target || {};
                  setBookingSearchFormData((prev) => ({
                    ...prev,
                    shipmentIdentifierDetails: {
                      ...prev?.shipmentIdentifierDetails,
                      shipmentPrefix: value,
                    },
                  }));
                }}
                onFocus={(e) => {
                  removeError(e, setError);
                }}
                error={
                  error && error["awbNumber"]
                    ? t(error["awbNumber"], { ns: "errors" })
                    : ""
                }
                wrapperClassName={`awb-prefix`}
              />

              <CommonInput
                type="text"
                inputType="number"
                label={t("COMMON.AWB_NUMBER")}
                value={
                  bookingSearchFormData?.shipmentIdentifierDetails
                    ?.masterDocumentNumber
                }
                onKeyDown={(evt) => formatInputTypeNumber(evt)}
                onChange={(e) => handleChangeOfAWB(e.target?.value)}
                onBlur={(e) => {
                  validateAWB(e.target?.value, setError, "awbNumber");
                }}
                onFocus={(e) => {
                  removeError(e, setError);
                }}
                error={
                  error && error["awbNumber"]
                    ? t(error["awbNumber"], { ns: "errors" })
                    : ""
                }
                wrapperClassName={"awb-suffix"}
                isOnlyErrorBorder
              />
            </div>
          </div>
          <div className="shipping-input-bottom">
            {!advancedSearch ? (
              <>
                <div
                  className="advanced-search-section"
                  onClick={() => advancedSearchAction(true)}
                >
                  <span className="link-label">{`${t(
                    "COMMON.ADV_SEARCH"
                  )}`}</span>
                  <img alt="upanddown-icon" src={downIcon} />
                </div>
                <button
                  type="button"
                  className="primary-button"
                  onClick={handleSubmit}
                >
                  {t("COMMON.SEARCH")}
                </button>
              </>
            ) : (
              <div
                className="advanced-search-section justify-content-start"
                onClick={() => {
                  advancedSearchAction(false);
                }}
              >
                <span className="link-label">{`${t(
                  "COMMON.ADV_SEARCH"
                )}`}</span>
                <img alt="upanddown-icon" src={upIcon} />
              </div>
            )}
          </div>

          {advancedSearch ? (
            <div className="input-row">
              <div className="form-group autocomplete-dropdown">
                <div className="p-float-label input-wrapper">
                  <ProductAutocomplete
                    selectedProduct={
                      bookingSearchFormData?.advancedSearch?.product
                    }
                    setSelectedProduct={(e) => {
                      setBookingSearchFormData((prev) => ({
                        ...prev,
                        advancedSearch: { ...prev.advancedSearch, product: e },
                      }));
                    }}
                    products={products}
                    placeholder={t(PRODUCT_PLACEHOLDER)}
                  />
                  <label>{t("COMMON.PRD")}</label>
                </div>
              </div>

              <CommonDropDown
                className={"booking-status-dropdown"}
                value={bookingSearchFormData?.advancedSearch?.bookingStatus}
                options={SHIPMENT_STATUS}
                label={t("SHIPMENT_LIST.SHP_STATUS")}
                onChange={(e) => {
                  const { value } = e.target;
                  setBookingSearchFormData((prev) => ({
                    ...prev,
                    advancedSearch: {
                      ...prev.advancedSearch,
                      bookingStatus: value,
                    },
                  }));
                }}
              />
            </div>
          ) : (
            <></>
          )}

          {advancedSearch && (
            <div className="advanced-search-section">
              <button
                type="button"
                className="primary-button"
                onClick={handleSubmit}
              >
                {t("COMMON.SEARCH")}
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="shipment-track-table">
        <div className="table-filters">
          <SelectButton
            className="common-select-button"
            value={selectedFilter}
            options={filterOptionsValues}
            onChange={(e) => {
              if (e.value) {
                handleFilterChange(e.value);
              }
            }}
          />
          <div className="filter-right-side">
            {isShowSmartTrack && trackAwbs && trackAwbs?.length !== 0 && (
              <div className="all-smart-link" onClick={allSmartTrackLinkClick}>
                <img src={liveTrack} className="smart-track-icon" />
                {t("SHIPMENT_LIST.ALL_SMART_TRACK")}
              </div>
            )}
            <CommonFilter
              filterDetailsArray={[
                {
                  label: t("COMMON.ALL"),
                  isChecked: statusFilters.includes("All"),
                  onChange: () => setStatusFilters(["All"]),
                },
                {
                  label: t("MY_SHIPMENTS.ON_TRACK"),
                  isChecked: statusFilters.includes("On Track"),
                  onChange: () => onFilterOptionsChange("On Track"),
                },
                {
                  label: t("MY_SHIPMENTS.DELAYED"),
                  isChecked: statusFilters.includes("Delayed"),
                  onChange: () => onFilterOptionsChange("Delayed"),
                },
                {
                  label: t("MY_SHIPMENTS.NOT_ACCEPTED"),
                  isChecked: statusFilters.includes("Not Yet Accepted"),
                  onChange: () => onFilterOptionsChange("Not Yet Accepted"),
                },
              ]}
              applyFilterClick={filterOnClickHandler}
              filterHeader={t("COMMON.FILTER_BY_STATUS")}
              resetFilterClick={resetFilterClickHandler}
            />
          </div>
        </div>
        <div className="common-list-table-scroll">
          <table className={`common-list-table ${isShowSmartTrack ? 'smart-tracked' : ''}`}>
            <tr className="table-header">
              <th className="header-cell">
                <span className="label-with-sort">
                  {t("COMMON.AWB")}
                  <img
                    className={`tp-sort-icon`}
                    src={getSortArrowByType(sortField, "AwbNumber")}
                    onClick={() => handleSort("AwbNumber")}
                  />
                </span>
              </th>
              <th className="header-cell">{t("COMMON.ORG_DEST")}</th>
              <th className="header-cell">
                <span className="label-with-sort">
                  {t("COMMON.SHIPMT_DATE")}
                  <img
                    className={`tp-sort-icon`}
                    src={getSortArrowByType(sortField, "ShipmentDate")}
                    onClick={() => handleSort("ShipmentDate")}
                  />
                </span>
              </th>
              <th className="header-cell">
                <span className="label-with-sort">
                  {t("COMMON.STATUS")}
                  <img
                    className={`tp-sort-icon`}
                    src={getSortArrowByType(sortField, "Status")}
                    onClick={() => handleSort("Status")}
                  />
                </span>
              </th>
              <th className="header-cell">
                <span>{t("COMMON.SHIPMENT_INFO")}</span>
              </th>
              <th className="header-cell" />
              {isShowSmartTrack && <th className="header-cell" />}
            </tr>
            <Divider coverage="100%" />
            <tbody className="table-body">
              {awbList?.length !== 0 ? (
                awbList.map((shipment, index) => {
                  const {
                    awbNumber,
                    icon,
                    orgDes,
                    shipmentDate,
                    mainStatus,
                    toaStatus,
                    toaStatusDelay,
                    shipmentInfo,
                    subStatusColorClassName,
                    shortDescription,
                    trackedShipmentID,
                  } = getFormattedDataForTable(shipment);

                  return (
                    <React.Fragment key={index}>
                      <tr
                        key={index}
                        className={`body-row ${index === 0 || index % 2 === 0 ? "even" : ""
                          }`}
                      >
                        <td className="body-cells awb-column" onClick={(e) => {
                          e.stopPropagation();
                          awbRowClickHandler(shipment)
                        }} >
                          {icon}
                          {awbNumber}
                        </td>
                        <td className="body-cells">{orgDes}</td>
                        <td className="body-cells">{shipmentDate}</td>
                        <td className="body-cells">
                          <div className="status-wrapper">
                            <span className="status-text">{mainStatus}</span>
                            {toaStatus && (
                              <span
                                className={`sub-status-delay ${subStatusColorClassName || ""
                                  }`}
                              >
                                {toaStatus}
                                {toaStatusDelay ? (
                                  <span className="delay-time">
                                    {" "}
                                    ({toaStatusDelay})
                                  </span>
                                ) : (
                                  <></>
                                )}
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="body-cells">
                          <div className="info-wrapper">
                            <div className="shipment-info">{shipmentInfo}</div>
                            {shortDescription && (
                              <div className="awb-shortDetails">
                                {shortDescription}
                              </div>
                            )}
                          </div>
                        </td>
                        <td
                          className={`body-cells link-color ${["Queued", "Confirmed"].includes(mainStatus)
                            ? "disabled"
                            : ""
                            }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            viewClickHandler(shipment);
                          }}
                        >
                          {t("MY_SHIPMENTS.TP_LABEL")}
                        </td>
                        {isShowSmartTrack && <td
                          className={`body-cells link-color smart-track-col ${isEmpty(trackedShipmentID) ? "disabled" : ""
                            }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSmartTrackClick(trackedShipmentID)
                          }
                          }
                        >
                          {isEmpty(trackedShipmentID) ? (
                            <div className="margin-adjust-tp" />
                          ) : (
                            <img src={liveTrack} className="smart-track-icon" />
                          )}
                          {t("MY_SHIPMENTS.SMART_TRCK")}
                        </td>}
                      </tr>
                      <Divider coverage="100%" />
                    </React.Fragment>
                  );
                })
              ) : (
                <label className="no-data-avilable">
                  {t("PERMANENT_BOOKING.NO_DATA")}
                </label>
              )}
            </tbody>
          </table>
        </div>
        {awbList && paginationData.totalPages > 1 && (
          <div className="paginationWrapper">
            <PaginatorComponent
              currentPage={paginationData.currentPageNumber}
              rowCount={paginationData.recordsPerPage}
              totalRecords={paginationData.combinedPages}
              onPageIndexChange={onPageIndexChange}
              isHotUpdateNeeded={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackShipmentListView;